module.exports = __webpack_public_path__ + "img/ip_loading.319defa0.gif";